import React from 'react';
import { Box, Skeleton } from '@mui/material';

const OrdersSkeleton = ({ count = 10 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: 1.5, md: 2 },
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        p: { xs: 1, md: 1.5 },
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            p: { xs: 2, md: 2.5 },
            borderRadius: 3,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          {/* Header com canal e data */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
            <Skeleton variant="text" width={100} height={20} />
          </Box>
          
          {/* Título do pedido */}
          <Skeleton variant="text" width="80%" height={24} />
          
          {/* Informações do pedido */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Skeleton variant="text" width="60%" height={16} />
            <Skeleton variant="text" width="70%" height={16} />
            <Skeleton variant="text" width="50%" height={16} />
          </Box>
          
          {/* Status */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Skeleton variant="rectangular" width={70} height={28} sx={{ borderRadius: 2 }} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default OrdersSkeleton;